import _ from 'lodash';
import { linkedToRecordTitles } from '../../lib/sql-fragments';

const LOAD_DELAY = 40;

export default class RecordLinkLoader {
  _waiters;
  _memory;
  _source;
  _waitingTimeout;
  constructor(source) {
    this._waiters = [];
    this._memory = {};
    this._source = source;
  }

  invalidate(ids) {
    if (!ids) {
      this._memory = {};
    } else {
      for (const id of ids) {
        delete this._memory[id];
      }
    }
  }

  getRecordLinkTitles(ids) {
    return ids.map((id) => this._memory[id]);
  }

  // Let callers fill in the cache. This is an optimization because we fetch titles in the
  // filter picker also. Let one populate the other.
  setRecordLinkTitle(id, title) {
    if (title == null) {
      delete this._memory[id];
    } else {
      this._memory[id] = title;
    }
  }

  fetch(recordLinkField, handler) {
    const idsToFetch = {};

    for (const id of recordLinkField.ids) {
      if (this._memory[id]) {
        handler(null, this._memory);
      } else {
        idsToFetch[id] = id;
      }
    }

    const ids = Object.keys(idsToFetch);

    if (!ids.length) {
      // we don't need to do anything, all ID's could be served from the cache
      return;
    }

    recordLinkField.ids = ids;

    this._waiters.push({ recordLinkField, callback: handler });

    clearTimeout(this._waitingTimeout);

    this._waitingTimeout = setTimeout(this.fetchWaitingFields, LOAD_DELAY);
  }

  fetchWaitingFields = () => {
    const groups = {};

    const waiters = this._waiters.slice();
    this._waiters = [];

    for (const waiter of waiters) {
      const { formID } = waiter.recordLinkField;

      if (!groups[formID]) {
        groups[formID] = [];
      }

      groups[formID].push(waiter);
    }

    for (const formID of Object.keys(groups)) {
      const ids = [];
      const callbacks = [];

      for (const context of groups[formID]) {
        ids.push.apply(ids, context.recordLinkField.ids);
        // @ts-ignore
        callbacks.push(context.callback);
      }

      const uniqueIDs = _.uniq(ids);
      const sql = linkedToRecordTitles(formID, uniqueIDs);

      this._source.dataSource.source.query({ q: sql }, (err, rows) => {
        const records = {};

        if (err) {
          for (const id of uniqueIDs) {
            this._memory[id] = records[id] = records[id] || {};
          }

          for (const handler of callbacks) {
            // @ts-ignore
            handler(err, records);
          }
          return;
        }

        for (const row of rows) {
          records[row._record_id] = row;
        }

        // make sure each requested ID gets an entry so we can detect deleted records
        for (const id of uniqueIDs) {
          this._memory[id] = records[id] = records[id] || {};
        }

        for (const handler of callbacks) {
          // @ts-ignore
          handler(err, records);
        }
      });
    }
  };
}
